import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import type { AttendContactLateJson } from '@/types/domain/attendContact/entities/attendContactLateEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import LateInfo from '@/domain/attendContact/component/LateInfo';

/**
 * プロパティ
 */
export type ConfirmInput = {
  /** データ */
  data: AttendContactLateJson | undefined,
  /** 送信 */
  onSend: (input: AttendContactLateJson | undefined) => void,
}

const Confirm: React.FC<ConfirmInput> = ({ data, onSend }) => (
  <Dialog
    open={data !== undefined}
    onClose={() => onSend(undefined)}
    fullScreen
    TransitionComponent={DialogTransition}
  >
    <DialogTitle title="遅刻連絡" />
    <DialogContent>
      <p>内容を確認し問題なければ、「送信」ボタンを押してください。</p>
      {data && <LateInfo data={data} />}
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => onSend(data)} color="primary">
        送信
      </Button>
      <Button variant="contained" onClick={() => onSend(undefined)} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default Confirm;
